import createAccentInsensitiveRegex from '../createAccentInsensitiveRegex.js';

export default {
  getPathExpression: (path, value) => ({
    [path.join('.')]: {
      $regex: `^${createAccentInsensitiveRegex(value)}$`,
      $options: 'i'
    }
  })
};
